"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBreakpoint = function (windowWidth, theme) {
    var result;
    var breakpoints = theme.global.breakpoints;
    Object.keys(breakpoints).some(function (name) {
        var breakpoint = breakpoints[name];
        if (breakpoint) {
            if (breakpoint.minValue <= windowWidth && (!breakpoint.maxValue || breakpoint.maxValue >= windowWidth)) {
                result = name;
                return true;
            }
        }
        return false;
    });
    return result;
};
//# sourceMappingURL=responsive.js.map